import arrow from "../../icons/arrow.svg";
import './style.css'
import { useEffect, useState } from "react";
import closeIcon from "../../icons/close.svg";
import questionBigIcon from "../../icons/question-big.svg";
import Markdown from 'react-markdown'
import { GetVehicleOffer } from "../../api/vehicles";

const Offer = ({ offer, setShow }) => {
    return <div>
        <div style={{ background: "#0000004D", position: "fixed", top: 0, left: 0, right: 0, bottom: 0 }}></div>
        <div style={{
            background: "white",
            position: "fixed",
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            left: 0,
            right: 0,
            bottom: 0,
            height: 538,
            zIndex: 9999
        }}>
            <button onClick={() => setShow(false)}
                style={{
                    position: "absolute",
                    right: 16,
                    top: 16,
                    padding: 8,
                    border: 0,
                    background: "#F1F1F1",
                    borderRadius: 8
                }}>
                <img src={closeIcon} style={{ display: "block" }} />
            </button>
            <div style={{ marginTop: 42, textAlign: "left", padding: 16, height: 500, overflow: "auto" }}>
                <Markdown>{offer}</Markdown>
                <div style={{ height: 100 }} />
            </div>
        </div>
    </div>
}

const Index = ({ vehicleId }) => {
    const [show, setShow] = useState(false)
    const [offer, setOffer] = useState(null)
    useEffect(() => {
        if (show && !offer && vehicleId) {
            GetVehicleOffer(vehicleId).then((data) => setOffer(data.offer))
        }
    }, [show])
    return <>
        {show && <Offer setShow={setShow} offer={offer} />}
        <div className={"offer-link"} onClick={() => setShow(!!vehicleId)}>
            {vehicleId && <div>Правила оплаты</div>}
        </div>
    </>
}


export default Index